import { render, staticRenderFns } from "./TransactionsList.vue?vue&type=template&id=28076ec2"
import script from "./TransactionsList.vue?vue&type=script&lang=ts"
export * from "./TransactionsList.vue?vue&type=script&lang=ts"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../../qraved-ordering-backoffice/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports